const appBaseName = "/registrazioneJwt"

const ignoreRedirectRouteList = [
  "/errore",
  "/errore/ocr",
  "/verifica-email",
  "/summary",
  "/errore/promo",
  "/registrazione-scaduta",
  "/registrazione-semplificata-pdv",
  "/registrazione-pdv",
  //dev
  // "/el-development",
  // "/registrazione-semplificata-pdv/riepilogo-dati-ocr",
  // "/registrazione-semplificata-pdv/bonus",
  // "/codice-fiscale",
  // "/indirizzo-residenza",
  // "/contatti",
  // "/dati-di-accesso",
  // "/bonus",
  // "/dati-documento",
  // "/limiti-ricarica",
  // "/termini-e-condizioni",
  // "/termini-e-condizioni-ocr",
  // "/thankyou",
  // "/thankyou/pdv",
  // "/errore/codice-fiscale",
  // "/errore/conto-punto-vendita",
  // "/errore/dati-incongruenti",
  // "/riepilogo-dati-ocr",
]

const callbackPages = ["/ocr-callback/cliente", "/ocr-callback/pdv"]

const defaultDate = new Date("01/01/2000")

const PDFUrls = () => {
  const isSsr = typeof window === "undefined"

  return {
    privacy: isSsr
      ? process.env.APP_PRIVACY_POLICY_URL
      : window.APP_PRIVACY_POLICY_URL,
    contract: isSsr ? process.env.APP_CONTRACT_URL : window.APP_CONTRACT_URL,
    termsAndConditions: isSsr
      ? process.env.APP_TERMS_OF_USE_URL
      : window.APP_TERMS_OF_USE_URL,
  }
}

export {
  PDFUrls,
  appBaseName,
  callbackPages,
  defaultDate,
  ignoreRedirectRouteList,
}
